import { getAccessMember } from '../api/getAccessMember/getAccessMember';
import { AccessMemberResponse } from '../model/types/AccessMemberResponse';

export const fetchAccessMember = async (): Promise<AccessMemberResponse> => {
  const accessMember = await getAccessMember();

  const newPermittedSections = accessMember?.map((section) => section.section);

  return {
    permittedSections: newPermittedSections,
    accessMember,
  };
};
